import { Color, ColorTypes } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';
import React from 'react';

import { SignedInNavigationScreenNavigationProp } from '../../../../../../routes/types';
import {
  tableParse,
  Offer,
  EquityTableItemProps,
} from '../../../../../NewApplication/Product/components/Equity/constants';

import { Desktop } from './desktop';
import { Mobile } from './mobile';
import { Tablet } from './tablet';

export interface EditProductProps {
  data: Offer;
  amountItem: number;
  priceItem: number;
  totalPrice: number;
  handleChangeAmountItem: (value: number) => void;
  handleChangePriceItem: (value: number) => void;
  equityOperationType: string;
}

export interface EditProductItemProps {
  item: Partial<EquityTableItemProps> & {
    priceChangeTaxValue: number;
    lotSize: number;
  };
  iconColor: string;
  amountItem: number;
  totalPrice: number;
  priceItem: number;
  onViewOffers: () => void;
  handleChangeAmountItem: (value: number) => void;
  handleChangePriceItem: (value: number) => void;
  lateralBarColor: ColorTypes.Option;
}

const EditProductItem: React.FC<EditProductProps> = ({
  equityOperationType = 'Compra',
  ...props
}) => {
  const item = tableParse(props.data);
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();

  const priceChangeTaxIsPositive = props.data?.quote.priceChangeTax >= 0;
  const iconColorPositive = 'feedback.success.default';
  const iconColorNegative = 'feedback.error.default';
  const iconColor = priceChangeTaxIsPositive ? iconColorPositive : iconColorNegative;

  const lateralBarColor =
    equityOperationType === 'Compra'
      ? Color['product.rendavariavelbuy']
      : Color['product.rendavariavelsale'];

  const itemDate = {
    ...item,
    priceChangeTaxValue: props.data.quote.priceChangeTax,
    lotSize: props.data.quote.lotSize,
  };

  const onViewOffers = () => {
    const data = { ...props.data, canUpdate: true };
    navigate('EquityOffersBookModal', data);
  };

  const params = {
    iconColor,
    item: itemDate,
    lateralBarColor: lateralBarColor as ColorTypes.Option,
    onViewOffers,
    ...props,
  };

  const layout = useBreakpointValue({
    base: <Mobile {...params} />,
    sm: <Tablet {...params} />,
    lg: <Desktop {...params} />,
  });

  return layout;
};

export const EditProduct = React.memo(EditProductItem);
